"use strict";

var _toConsumableArray = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var R = __importStar(require("ramda"));

var formatFieldDataListItem_1 = require("./formatFieldDataListItem");

var bindDataWithInitialData = function bindDataWithInitialData() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var initialList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var result = [];

  var leftInitialList = _toConsumableArray(initialList);

  var toResultObject = function toResultObject(data, initialData) {
    return {
      data: data,
      initialData: initialData
    };
  };

  var findById = function findById(id) {
    return function (el) {
      return R.path(['id'], el) === id;
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (!item || !item.id && typeof item !== 'string') {
        result.push(toResultObject(item, null));
        continue;
      }

      var initialDataInx = leftInitialList.findIndex(item.id ? findById(item.id) : R.equals(item));
      var initialData = null;

      if (initialDataInx !== -1) {
        initialData = leftInitialList[initialDataInx];
        leftInitialList.splice(initialDataInx, 1);
      }

      result.push(toResultObject(item, initialData));
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = leftInitialList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _item = _step2.value;

      if (!_item || !_item.id && typeof _item !== 'string') {
        continue;
      }

      result.push(toResultObject(null, _item));
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return result;
};

exports.formatFieldDataList = function (type, data, _ref, options) {
  var fieldSchema = _ref.fieldSchema,
      schema = _ref.schema,
      initialData = _ref.initialData;
  return R.pipe(function (data) {
    return bindDataWithInitialData(data, initialData);
  }, // // @ts-ignore
  // data => console.log('binded data', data) || data,
  R.map(function (item) {
    return formatFieldDataListItem_1.formatFieldDataListItem(type, item.data, {
      fieldSchema: fieldSchema,
      schema: schema,
      initialData: item.initialData,
      initialListData: initialData
    }, options);
  }), R.filter(function (item) {
    return Boolean(item);
  }), R.groupBy(R.prop('type')), R.mapObjIndexed(R.map(R.prop('data'))))(data);
};